<template>
  <div class="z-50 relative bg-white px-16">
    <div
      class="flex justify-between items-center px-4 py-6 sm:px-6 md:justify-start md:space-x-10"
    >
      <div class="flex justify-start lg:w-0 lg:flex-1" style="min-width: 250px;">
        <router-link :to="{ name: 'home' }">
          <span class="sr-only">Главная</span>
          
          <!--
          <img
            class="h-8 w-auto sm:h-10"
            style="min-width: 250px;"
            src="/images/fdm-logo-full.png"
            alt=""
          />
          -->
          
          <img
            class="w-auto h-12"
            style="min-width: 150px;"
            src="/images/fdm-logo-full.png"
            alt=""
          />
          
        </router-link>
        <router-link
          class="text-base font-medium text-gray-500 hover:text-gray-900 hidden 2xl:block ml-12 pt-3"
          :to="{ name: 'home' }"
          >Образовательная платформа</router-link
        >
      </div>
      

      <div class="-mr-2 -my-2 md:hidden">
        <button
          @click="mobileNavToggled = true"
          type="button"
          class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
          aria-expanded="false"
        >
          <span class="sr-only">Open menu</span>
          <!-- Heroicon name: outline/menu -->
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>
      <nav class="hidden md:flex space-x-10">
        <!--
        <router-link
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'home' }"
          >Главная</router-link
        >
        -->
        <!--
        <router-link
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'home' }"
          >Образовательная платформа</router-link
        >
        -->





        <router-link
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'articles' }"
          >Статьи</router-link
        >

        <router-link
          v-if="(authenticated && (!user.is_simple)) || (!authenticated)"
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'courses' }"
          >Курсы</router-link
        >
        <router-link
          v-if="(authenticated && (!user.is_simple)) || (!authenticated)"
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'departments' }"
        >
          Кафедры
        </router-link>

        <router-link
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'school' }"
          >Пациентам</router-link
        >


        <router-link
          v-if="!authenticated"
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'signin' }"
          >Вход</router-link
        >

        <router-link
          v-if="!authenticated"
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          to="/register#reg"
          >Регистрация</router-link
        >



        <!-- <router-link
          v-if="authenticated"
          class="text-base font-medium text-gray-500 hover:text-gray-900"
          :to="{ name: 'dashboard' }"
        >
          Профиль
        </router-link> -->

        <div v-if="(user) && (user.is_admin || user.is_author)" class="relative">
          <!-- Item active: "text-gray-900", Item inactive: "text-gray-500" -->
          <button
            @click="dropdownToggled = !dropdownToggled"
            ref="dropdownRef"
            type="button"
            class="text-gray-500 group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            aria-expanded="false"
          >
            <span>Администрирование</span>
            <!--
            Heroicon name: solid/chevron-down

            Item active: "text-gray-600", Item inactive: "text-gray-400"
          -->
            <svg
              class="text-gray-400 ml-2 h-5 w-5 group-hover:text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <!--
          'More' flyout menu, show/hide based on flyout menu state.

          Entering: "transition ease-out duration-200"
            From: "opacity-0 translate-y-1"
            To: "opacity-100 translate-y-0"
          Leaving: "transition ease-in duration-150"
            From: "opacity-100 translate-y-0"
            To: "opacity-0 translate-y-1"
        -->
          <div
            v-if="dropdownToggled"
            class="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0"
          >
            <div
              class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden"
            >
              <div
                class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8"
              >
                <router-link
                  v-if="(user) && (user.is_admin)"
                  :to="{ name: 'adminDepartments' }"
                  class="-m-3 p-3 block rounded-md hover:bg-gray-50"
                  >Кафедры [adm]</router-link
                >
                <router-link
                  v-if="(user) && (user.is_admin)"
                  :to="{ name: 'adminCategories' }"
                  class="-m-3 p-3 block rounded-md hover:bg-gray-50"
                  >Категории [adm]</router-link
                >
                <router-link
                  v-if="(user) && (user.is_admin)"
                  :to="{ name: 'adminCourseStates' }"
                  class="-m-3 p-3 block rounded-md hover:bg-gray-50"
                  >Состояния курсов [adm]</router-link
                >
                <router-link
                  v-if="(user) && (user.is_admin)"
                  :to="{ name: 'adminChapterStates' }"
                  class="-m-3 p-3 block rounded-md hover:bg-gray-50"
                  >Состояния глав [adm]</router-link
                >
                <router-link
                  :to="{ name: 'adminCourses' }"
                  class="-m-3 p-3 block rounded-md hover:bg-gray-50"
                  >Курсы [adm]</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div
        v-if="authenticated"
        class="hidden md:flex items-center justify-end md:flex-1 lg:w-0"
      >
        <div
          class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
        >
          <!-- Profile dropdown -->
          <div class="ml-3 relative z-50">
            <div>
              <button
                @click="profileDropdown = !profileDropdown"
                ref="profleDropdownRef"
                type="button"
                class="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                id="user-menu"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span class="sr-only">Open user menu</span>
                <!-- <img
                  v-if="user.mainphoto"
                  :src="user.mainphoto"
                  class="h-8 w-8 rounded-full"
                  alt=""
                /> -->
                <img
                  v-if="user.userphoto"
                  :src="user.userphoto"
                  class="h-8 w-8 rounded-full"
                  style="box-shadow: 0 0 10px gray"
                  alt=""
                />
                <img
                  v-else
                  src="/images/no_avatar.png"
                  class="h-8 w-8 rounded-full"
                  alt=""
                />
              </button>
            </div>

            <!--
            Dropdown menu, show/hide based on menu state.

            Entering: "transition ease-out duration-200"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          -->
            <div
              v-if="profileDropdown"
              class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu"
            >
              <router-link
                v-if="authenticated"
                :to="{ name: 'dashboard' }"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                Профиль
              </router-link>
              <!--
              <router-link
                v-if="authenticated"
                :to="{ name: 'user_profile_edit' }"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                Редактировать профиль
              </router-link>
              -->

              <a
                v-if="authenticated"
                @click.prevent="signOut"
                href="#"
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                role="menuitem"
              >
                Выход
              </a>
            </div>
          </div>
        </div>

        <router-link
          v-if="!authenticated"
          :to="{ name: 'signin' }"
          class="whitespace-nowrap text-base border rounded-md shadow-sm px-4 py-2 font-medium text-gray-500 hover:text-gray-900"
          >Вход</router-link
        >
        <router-link
          v-if="!authenticated"
          to="/register#reg"
          class="whitespace-nowrap text-base border rounded-md shadow-sm px-4 py-2 font-medium text-gray-500 hover:text-gray-900"
          >Регистрация</router-link
        >
        <!-- <a
          href="#"
          class="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
        >
          Sign up
        </a> -->
      </div>
    </div>

    <!--
    Mobile menu, show/hide based on mobile menu state.

    Entering: "duration-200 ease-out"
      From: "opacity-0 scale-95"
      To: "opacity-100 scale-100"
    Leaving: "duration-100 ease-in"
      From: "opacity-100 scale-100"
      To: "opacity-0 scale-95"
  -->
    <div
      class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
    >
      <!-- схлопывающееся мобильное меню: -->
      <div v-if="mobileNavToggled" class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
        <div class="pt-5 pb-6 px-5">
          <div class="flex items-center justify-between">
            <div>
              <img class="h-8 w-auto" src="/images/fdm-logo-full.png" alt="" />
            </div>
            <div class="-mr-2">
              <button
                @click="mobileNavToggled = false"
                type="button"
                class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              >
                <span class="sr-only">Close menu</span>
                <!-- Heroicon name: outline/x -->
                <svg  class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div v-if="true" class="mt-6">
            <nav class="grid grid-cols-1 gap-7">
              <router-link
                :to="{ name: 'home' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/view-grid -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">Главная</div>
              </router-link>






              <router-link
                :to="{ name: 'articles' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/cursor-click -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Статьи
                </div>
              </router-link>

              <router-link              
                v-if="(authenticated && (!user.is_simple)) || (!authenticated)"
                :to="{ name: 'courses' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/shield-check -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Курсы
                </div>
              </router-link>

              <router-link
                v-if="(authenticated && (!user.is_simple)) || (!authenticated)"
                :to="{ name: 'departments' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/view-grid -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Кафедры
                </div>
              </router-link>


              <router-link
                :to="{ name: 'school' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/cursor-click -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Пациентам
                </div>
              </router-link>

              <router-link
                v-if="authenticated"
                :to="{ name: 'dashboard' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/chart-bar -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Профиль
                </div>
              </router-link>

              <router-link
                v-if="!authenticated"
                to="/register#reg"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/shield-check -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Регистрация
                </div>
              </router-link>


              <router-link
                v-if="!authenticated"
                :to="{ name: 'signin' }"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/shield-check -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Вход
                </div>
              </router-link>

              <a
                v-if="authenticated"
                @click.prevent="signOut"
                href="#"
                class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50"
              >
                <div
                  class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-indigo-500 text-white"
                >
                  <!-- Heroicon name: outline/shield-check -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div class="ml-4 text-base font-medium text-gray-900">
                  Выход
                </div>

              </a>




            </nav>
          </div>
        </div>

        <div v-if="(user) && (user.is_admin || user.is_author)" class="py-6 px-5">
          <div class="relative mb-6">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center">
              <span class="px-3 bg-white text-lg font-medium text-gray-900">
                Администрирование
              </span>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-4">
            <router-link
              v-if="(user) && (user.is_admin)"
              :to="{ name: 'adminDepartments' }"
              class="text-base font-medium text-gray-900 hover:text-gray-700"
              >Кафедры [adm]</router-link
            >
            <router-link
              v-if="(user) && (user.is_admin)"
              :to="{ name: 'adminCategories' }"
              class="text-base font-medium text-gray-900 hover:text-gray-700"
              >Категории [adm]</router-link
            >
            <router-link
              v-if="(user) && (user.is_admin)"
              :to="{ name: 'adminCourseStates' }"
              class="text-base font-medium text-gray-900 hover:text-gray-700"
              >Состояния курсов [adm]</router-link
            >
            <router-link
              v-if="(user) && (user.is_admin)"
              :to="{ name: 'adminChapterStates' }"
              class="text-base font-medium text-gray-900 hover:text-gray-700"
              >Состояния глав [adm]</router-link
            >
            <router-link
              :to="{ name: 'adminCourses' }"
              class="text-base font-medium text-gray-900 hover:text-gray-700"
              >Курсы [adm]</router-link
            >
          </div>
          <div class="mt-6">
            <!-- <a
              href="#"
              class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Sign up
            </a> -->
            <p
              v-if="!authenticated"
              class="mt-6 text-center text-base font-medium text-gray-500"
            >
              Existing customer?
              <a href="#" class="text-indigo-600 hover:text-indigo-500">
                Sign in
              </a>
            </p>
          </div>
        </div>
      </div>
      <!-- конец схлопывающегося мобильного меню: -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      dropdownToggled: false,
      mobileNavToggled: false,
      profileDropdown: false,
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace(
          {
            name: "home",
          },
          () => {} // это нужно чтобы не было ексепшена при перенаправлении "с себя на себя", т.е. с home на home.
        );
      });
    },
  },
  created() {
    let self = this;

    window.addEventListener("click", (e) => {

      if ((self.$refs.profleDropdownRef) && (!self.$refs.profleDropdownRef.contains(e.target))) {
        self.profileDropdown = false;
      }

      if ((self.$refs.dropdownRef) && (!self.$refs.dropdownRef.contains(e.target))) {
        self.dropdownToggled = false;
      }

    });
  },
};
</script>